// extracted by mini-css-extract-plugin
export var bgOverlay = "PageHeader-module__bgOverlay___qpQkj";
export var header = "PageHeader-module__header___-hMwe";
export var headerContent = "PageHeader-module__headerContent___cZIrT";
export var heading = "PageHeader-module__heading___oSdxn";